const state = {
  schoolsTestingStudents: [58953, 58706, 56235, 54618, 41576, 50707, 54828, 51581, 51583, 51591, 51599, 51600, 51597, 50402, 51590,
    51574, 51588, 51586, 51587, 51589, 51585, 51596, 51576, 51595, 51592, 51594, 51593, 51598, 51577, 51578, 51579,
    51601, 51602, 51603, 51580, 8943, 51582, 51584, 51573, 33473, 9111, 37940, 50417, 50803, 51763, 52492, 51408, 50802,
    54331, 54479, 54635, 56284, 43915, 55417, 55210, 56149, 54818, 56266, 57418, 57426, 57424, 57426, 57420, 57421, 57422, 57423, 57425, 57427, 57419, 57471
  ]
}

const getters = {
  modulesSchoolFeatures (state, getters, rootState, rootGetters) {
    return rootGetters.schoolFeatures
  },
  isReductionsActive (state, getters) {
    return getters.modulesSchoolFeatures.indexOf('subject_reductions') > -1
  },
  isKindergarten (state, getters, rootState) {
    return getters.modulesSchoolFeatures.indexOf('calendar_kindergarten') > -1
  },
  theSchool (state, getters, rootState) {
    return rootState.activeSchool ? rootState.activeSchool : window.SCHOOL ? window.SCHOOL : null
  },
  theSchoolCountry (state, getters, rootState) {
    return getters.theSchool && getters.theSchool.country ? getters.theSchool.country.toUpperCase() : 'DK'
  },
  isSchoolFeatureLocalePool (state, getters) {
    return getters.modulesSchoolFeatures.indexOf('lokalpulje') > -1
  },
  isSchoolTestingStudents (state, getters, rootState) {
    if (window.SCHOOL && window.SCHOOL.features) {
      return window.SCHOOL.features.includes('calendar_student')
    }

    const school = rootState && rootState.activeSchool ? rootState.activeSchool : window.SCHOOL
    const schoolId = school && school.id ? school.id : ''

    return state.schoolsTestingStudents.includes(schoolId)
  },
  isSchoolSFOActive (state, getters, rootState) {
    const isActivated = getters.modulesSchoolFeatures.indexOf('calendar_club') > -1
    const schoolId = getters.schoolId
    const danishSchoolsWithoutSFO = [57418]
    if (isActivated) {
      return true
    } else if (getters.theSchoolCountry === 'NO' || (getters.theSchoolCountry === 'DK' && danishSchoolsWithoutSFO.indexOf(schoolId) < 0)) {
      return true
    } else {
      return false
    }
  },
  isSubStatusPendingActive (state, getters, rootState) {
    const schoolId = getters.schoolId
    const schoolIdsTestingSubStatusPending = [51580]
    return schoolIdsTestingSubStatusPending.includes(schoolId)
  },
  isSchoolTestingTaskOverviewDesigner (state, getters) {
    const schoolId = getters.schoolId
    const schoolIdsTestingTaskOverviewDesigner = [62000, 7272, 59488, 59489, 62084]
    return schoolIdsTestingTaskOverviewDesigner.includes(schoolId)
  },
  isKmdUserQuotaActive (state, getters) {
    return getters.modulesSchoolFeatures.indexOf('kmd_absence') > -1
  }
}

export default {
  state,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/flipper.js